import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { createIOSButtonStyles } from '../../../theme/iosButtonStyles';
import { useTheme } from '@mui/material/styles';

const DashboardHeader = ({ onRefresh, loading }) => {
  const theme = useTheme();
  const iosButtonStyles = createIOSButtonStyles(theme);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={3}
    >
      <Box>
        <Typography variant="h4" gutterBottom>
          Content Check Analytics Dashboard
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          High-level statistics and trends for content checking activities
        </Typography>
      </Box>
      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={onRefresh}
        disabled={loading}
        sx={{
          ...iosButtonStyles.secondary,
          textTransform: 'none',
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
        }}
      >
        Refresh
      </Button>
    </Box>
  );
};

export default DashboardHeader;
